import { notification } from "antd";

import axios from "../../../config/axios";

// constant
import { BASE_URL_BETA } from "../../../constant/api";

export const getAnomalyDataList = async (params: any) => {
  try {
    const url = `${BASE_URL_BETA}/admin/monitor-data`;
    const response = await axios.get(url, { params: params });

    if (response && response.status === 200) {
      return response.data;
    }
  } catch (err: any) {
    notification.error({
      message: "Gagal memuat",
      placement: "topRight",
      duration: 2,
    });
    throw new Error(err);
  }
};

export const getAnomalyDataDetailList = async (AnomalyID: number) => {
  try {
    const url = `${BASE_URL_BETA}/admin/monitor-data/${AnomalyID}`;
    const response = await axios.get(url);

    if (response && response.status === 200) {
      return response.data;
    }
  } catch (err: any) {
    notification.error({
      message: "Gagal memuat",
      placement: "topRight",
      duration: 2,
    });
    throw new Error(err);
  }
};
